<template>
    <div class="test__wrapper" v-if="getRedirectUrl">
        Для прохождения {{ getTypeTitle[1] }} перейдите по
        <a :href="getRedirectUrl" target="__blank">cсылке</a>
    </div>
    <div class="test__wrapper" v-else>
        {{ getTypeTitle[0] }} не найден
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

let fromObject = {};

const examActions = [
    'startSession',
];

const examGetters = [
    'getSessionType',
    'getRedirectUrl',
];

export default {
    name: 'StartSession',
    data:() => ({}),
    computed: {
        getTypeTitle() {
            switch (this.getSessionType) {
                case 'test':
                    return [
                        'Тест',
                        'теста',
                    ];
                case 'survey':
                    return [
                        'Опрос',
                        'опроса',
                    ];
                case 'assessment':
                    return [
                        'assessment',
                        'assessment',
                    ];
                default:
                    return 'тест';
            }
        },
        ...mapGetters('exam', examGetters),
    },
    async created() {
        let url = new URL(`https://${window.rsvDomain}${fromObject.path}`);
        this.$store.getters['isMobileApp'] && url.searchParams.set('is_mobile_app', 'true');
        await this.startSession({
            activityId: this.$route.params.id,
            returnUrl: url.toString(),
        });

        if (this.getRedirectUrl) {
            window.location = this.getRedirectUrl;
        }
    },
    beforeRouteEnter (to, from, next) {
        fromObject = from;
        next();
    },
    methods: {
        ...mapActions('exam', examActions),
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/rem';

.test__wrapper {
    margin-top: rem(40);
    text-align: center;

    &, & > * {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: rem(32);
        line-height: rem(39);
        color: #2A2626;
    }

    a {
        color: #4663AB;
    }
}
</style>
